


import React from "react";

import { TableHeader } from "./TableHeader";
import { Column, } from "./types";
import styles from './styles.module.scss'
import { TableBody } from "./TableBody";
import { TableFooter } from "./TableFooter/inde";
import { EmptyData } from "./emptyData";

export type TableProps<T extends Record<string, unknown>> = BaseTableProps<T> & (TableWithFooter | TableWithoutFooter);

type BaseTableProps<T extends Record<string, unknown>> = {
  columns: Column<T>[];
  data: T[];
  onRowClick?: (rowData: T) => void;
  enableRowDrag?: boolean;
  showExportButton?: boolean;
  showPriorityButton?: boolean;
  isDraggingEnabled?: boolean;
  onExportClick?: () => void;
  onPriorityClick?: () => void;
  onRowRender?: (rowIndex: number) => React.HTMLAttributes<HTMLTableRowElement>;
};

type TableWithFooter = {
  showFooter?: boolean;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  onItemsPerPageChange: (itemsPerPage: number) => void;
};

type TableWithoutFooter = {
  showFooter: false;
};

const Table = <T extends Record<string, unknown>>(props: TableProps<T>) => {


  const hasData = props.data && props.data.length > 0;

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <TableHeader columns={props.columns} />
        {hasData ? (
          <TableBody 
          data={props.data} 
          columns={props.columns} 
          onRowClick={props.onRowClick}
          isDraggingEnabled={props.isDraggingEnabled}
          onRowRender={props.onRowRender}
           />
        ) : (
          <EmptyData colSpan={props.columns.length} />
        )}
      </table>
      {hasData && props.showFooter !== false && (
        <TableFooter
          currentPage={props.currentPage}
          itemsPerPage={props.itemsPerPage}
          onItemsPerPageChange={props.onItemsPerPageChange}
          onPageChange={props.onPageChange}
          totalItems={props.totalItems}
          showExportButton={props.showExportButton}
          showPriorityButton={props.showPriorityButton}
          onExportClick={props.onExportClick}
          onPriorityClick={props.onPriorityClick}
        />
      )}
    </div>

  );
};

export default Table;